export default class SoundSingle {
	constructor(sounder, id, path, callback) {
		this.id = id;
		this.path = path;
		this.callback = callback;
		this.ready = false;
		this.isPreloading = false;
		this.isPlaying = false;
		this.instances = new Array();
		this.counterID = 0;
		this.sounder = sounder;
		this.garbage = new Array();
	}


	preload() {
		createjs.Sound.alternateExtensions = ["mp3"];
		this.queue = new createjs.LoadQueue(false);
		this.queue.installPlugin(createjs.Sound);
		this.queue.addEventListener("fileload", jQuery.proxy(this.singlePreloaded, this));
		var a = new Array({ id: this.id, src: this.path });
		this.queue.loadManifest(a);
	}

	singlePreloaded(e) {
		this.isPreloading = false;
		this.ready = true;
		this.callback.call(null, SoundSingle.PRELOAD_COMPLETE, this);
	}

	play(lOneInstance, fadeIn,callback) {
		if (!this.ready) {
			console.log("Warning: sound " + this.id + " not already preloaded!");
			return;
		}
		if (lOneInstance) {
			if (!this.isPlaying) {
				this.doPlaySound(fadeIn,callback);
			} else {
				// console.log("Warning: sound " + this.id + " already playing!");
			}
		} else {
			this.doPlaySound(fadeIn);
		}
	}

	doPlaySound(fadeIn,callback) {
		var sndTmp
		this.isPlaying = true;
		sndTmp = createjs.Sound.play(this.id);
		sndTmp.intID = this.counterID++;
		sndTmp.addEventListener("complete", jQuery.proxy(this.endSound, this, sndTmp,callback));
		this.instances.push(sndTmp);
		if (fadeIn) {
			this.doFadeIn(sndTmp);
		}
	}

	getDuration() {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			//console.log(snd)
			return snd.duration;
		}

	}

	setStartTime(time) {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			//console.log(snd)
			snd.position = time*1000;
		}
  }

	endSound(sndTmp, callback) {
		var a = new Array();
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			if (snd.intID != sndTmp.intID) {
				a.push(snd)
			}
		}
		this.instances = a;
		if (this.instances.length == 0) {
			this.isPlaying = false;
		}
		this.callback.call(null, SoundSingle.SOUND_FINISHED_PLAYING, this);
		if (callback) {
			callback.call(null);
		}
	}

	playLoop(fadeIn, fadeOut, quanti) {
		if (!this.isPlaying) {
			this.isPlaying = true;
			var sndTmp = createjs.Sound.play(this.id);
			sndTmp.intID = this.counterID++;
			sndTmp.addEventListener("complete", jQuery.proxy(this.loopSound, this, sndTmp, quanti));
			this.instances.push(sndTmp);
			if (fadeIn) {
				this.doFadeIn(sndTmp);
			}
		} else {
			// console.log("Warning: sound " + this.id + " already playing!");
		}
	}

	loopSound(sndTmp, quanti) {
		if (quanti) {
			quanti--;
		}
		//console.log(this.id + " ||||>" + quanti)
		this.endSound(sndTmp);
		this.callback.call(null, SoundSingle.SOUND_LOOPING, this);
		if (quanti) {
			if (quanti > 1) {
				this.playLoop(null, null, quanti);
				this.sounder.updateVolume();
			}
		} else {
			this.playLoop();
			this.sounder.updateVolume();
		}
	}

	pause() {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			snd.paused = true;
		}

  }

	resume() {
		//debugger
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			snd.play();
			snd.paused = false;
		}

  }

	stop() {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			snd.stop();
		}
		this.killTween();
		this.instances = new Array();
		this.isPlaying = false;
		this.sounder.volume = this.sounder.maxVolume;
	}

	doFadeIn(sndTmp) {
		if (this.sounder.active) {
			console.log("Volume attuale: " + this.sounder.volume)
			//sndTmp.setVolume(0);
			var counter = { value: 0 };
			TweenMax.to(counter, Sounder.FADE_IN_TIME, { value: this.sounder.volume, onUpdate: jQuery.proxy(this.updateVolumeFading, this, sndTmp, counter) });
			this.garbage.push(counter);
		}
	}

	updateVolumeFading(snd, counter) {
		//console.log(counter.value)
		snd.setVolume(counter.value);
		this.sounder.volume = counter.value
	}

	setVolume(vol, lKill) {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			snd.setVolume(vol);
		}
		if (lKill) {
			this.killTween();
		}
	}

	killTween() {
		for (var x = 0; x < this.garbage.length; x++) {
			TweenMax.killTweensOf(this.garbage[x]);
		}
		this.garbage = new Array();
	}

	volumeFadeOut() {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			var counter = { value: this.sounder.volume };
			TweenMax.to(counter, Sounder.TOGGLE_FADE_IN_TIME, { value: 0, onUpdate: jQuery.proxy(this.updateVolumeFading, this, snd, counter) });
			this.garbage.push(counter);
		}
	}
	volumeFadeIn() {
		for (var x = 0; x < this.instances.length; x++) {
			var snd = this.instances[x];
			var counter = { value: this.sounder.volume };
			TweenMax.to(counter, Sounder.TOGGLE_FADE_OUT_TIME, { value: this.sounder.maxVolume, onUpdate: jQuery.proxy(this.updateVolumeFading, this, snd, counter) });
			this.garbage.push(counter);
		}
	}
}

SoundSingle.PRELOAD_COMPLETE = "preloadComplete";
SoundSingle.SOUND_FINISHED_PLAYING = "soundFinishedPlaying";
SoundSingle.SOUND_LOOPING = "soundLooping";
